"use client";

import styles from "@/styles/modules/components/rooms/checkboxes.module.scss";
import Image from "next/image";
import Link from "next/link";

import { BookMenuContext } from "@/context/bookMenuContext";
import { LanguageContext } from "@/context/languageContext";
import { Room } from "@/types/wordpress";
import { translate } from "@/utils/translate";

import { usePathname } from "next/navigation";
import { useContext, useEffect, useState } from "react";

interface CheckboxesProps {
  room: Room;
}

export default function Checkboxes({ room }: CheckboxesProps) {
  const { language } = useContext(LanguageContext);
  const pathname = usePathname();
  const { openBookMenu, setCurrentBookMenu } = useContext(BookMenuContext);
  const [currentRoom, setCurrentRoom] = useState<any>(room);

  const handleBookNow = () => {
    setCurrentBookMenu(1);
    openBookMenu();
  };

  useEffect(() => {
    setCurrentBookMenu(1);
  }, [pathname, setCurrentBookMenu]);

  useEffect(() => {
    setCurrentRoom(room);
  }, [language, room]);

  return (
    <section className={styles.checkboxes}>
      <div className={styles.checkboxesContainer}>
        <div className={styles.image} data-aos="fadeIn">
          {currentRoom.roomsCheckboxes &&
            currentRoom.roomsCheckboxes.checkboxesImage && (
              <Image
                src={currentRoom.roomsCheckboxes.checkboxesImage.node.link}
                alt={currentRoom.roomsCheckboxes.checkboxesImage.node.altText || "Imperial Riding School"}
                width={
                  currentRoom.roomsCheckboxes.checkboxesImage.node.mediaDetails
                    .width
                }
                height={
                  currentRoom.roomsCheckboxes.checkboxesImage.node.mediaDetails
                    .height
                }
                data-aos="fadeIn"
              />
            )}
        </div>
        <div className={styles.text}>
          <div className={styles.boxes}>
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxSize && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 0}>
                  <Image
                    alt="Square logo"
                    src="/icons/checkbox_square.svg"
                    width={27}
                    height={27}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxSize}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxDesk && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 1}>
                  <Image
                    alt="Desk logo"
                    src="/icons/checkbox_desk.svg"
                    width={43}
                    height={24}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxDesk}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxBalcony && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 2}>
                  <Image
                    alt="Plant logo"
                    src="/icons/checkbox_balcony.svg"
                    width={26}
                    height={31}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxBalcony}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxPeople && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 3}>
                  <Image
                    alt="Person logo"
                    src="/icons/checkbox_person.svg"
                    width={22}
                    height={26}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxPeople}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxTv && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 4}>
                  <Image
                    alt="Tv logo"
                    src="/icons/checkbox_tv.svg"
                    width={31}
                    height={25}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxTv}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxAccessible && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 5}>
                  <Image
                    alt="Accesible logo"
                    src="/icons/checkbox_accesible.svg"
                    width={28}
                    height={28}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxAccessible}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxBed && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 6}>
                  <Image
                    alt="Bed logo"
                    src="/icons/checkbox_bed.svg"
                    width={31}
                    height={21}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxBed}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxMinibar && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 7}>
                  <Image
                    alt="Coctail logo"
                    src="/icons/checkbox_coctail.svg"
                    width={23}
                    height={30}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxMinibar}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxCoffee && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 8}>
                  <Image
                    alt="Coffee logo"
                    src="/icons/checkbox_coffee.svg"
                    width={30}
                    height={30}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxCoffee}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxWifi && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 9}>
                  <Image
                    alt="Wifi logo"
                    src="/icons/checkbox_wifi.svg"
                    width={26}
                    height={22}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxWifi}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxBathub && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 10}>
                  <Image
                    alt="Bathub logo"
                    src="/icons/checkbox_bathub.svg"
                    width={37}
                    height={18}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxBathub}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxChurch && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 11}>
                  <Image
                    alt="Church logo"
                    src="/icons/checkbox_church.svg"
                    width={37}
                    height={36}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxChurch}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxTwoPeople && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 12}>
                  <Image
                    alt="Two people logo"
                    src="/icons/checkbox_2ppl.svg"
                    width={30}
                    height={28}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxTwoPeople}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxThreePeople && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 13}>
                  <Image
                    alt="Three people logo"
                    src="/icons/checkbox_3ppl.svg"
                    width={36}
                    height={28}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxThreePeople}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxFourPeople && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 14}>
                  <Image
                    alt="Four people logo"
                    src="/icons/checkbox_4ppl.svg"
                    width={42}
                    height={28}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxFourPeople}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxChromecast && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 15}>
                  <Image
                    alt="Chromecast logo"
                    src="/icons/checkbox_chromecast.svg"
                    width={36}
                    height={27}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxChromecast}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxSofa && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 16}>
                  <Image
                    alt="Sofa logo"
                    src="/icons/checkbox_sofa.svg"
                    width={47}
                    height={18}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxSofa}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxRoom && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 17}>
                  <Image
                    alt="Door logo"
                    src="/icons/checkbox_door.svg"
                    width={22}
                    height={37}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxRoom}</span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxPrivateSuite && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 18}>
                  <Image
                    alt="Lock logo"
                    src="/icons/checkbox_lock.svg"
                    width={22}
                    height={29}
                  />
                  <span>
                    {currentRoom.roomsCheckboxes.checkboxPrivateSuite}
                  </span>
                </div>
              )}
            {currentRoom.roomsCheckboxes &&
              currentRoom.roomsCheckboxes.checkboxAc && (
                <div className={styles.box} data-aos="fadeIn" data-aos-delay={100 * 19}>
                  <Image
                    alt="Air conditioning logo"
                    src="/icons/checkbox_ac.svg"
                    width={21}
                    height={19}
                  />
                  <span>{currentRoom.roomsCheckboxes.checkboxAc}</span>
                </div>
              )}
          </div>
          <div className={styles.button}>
            <Link href={`https://www.marriott.com/${language === 'de' ? 'de' : 'en-us'}/hotels/vieir-imperial-riding-school-autograph-collection/overview/`}
              target="_blank">
              {translate["bookNow"][language]}
            </Link>
            {/* <button onClick={handleBookNow}>
              {translate["bookNow"][language]}
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
}
